const PageStruct = {
    id: 'reset-password',
    useLayout: true,
    children: [{ id: 'reset-password', order: 1 }]
};

export default PageStruct;
